import { createSlice } from "@reduxjs/toolkit";
import { toastrCRUDSuccess } from "components/Common/AlertToastr";
import {
  commonHandleHttpMethodGet,
  commonHandleHttpMethodPost,
  commonHandleHttpMethodPutV2,
} from "helpers/erp_helper";
import { TEXT_POST, TEXT_PUT } from "helpers/name_helper";
import { LEAD_URL } from "helpers/url_helper";

export const fetchLeads = commonHandleHttpMethodGet(
  "LeadSlice/fetchLeads",
  LEAD_URL
);

export const createLead = commonHandleHttpMethodPost(
  "LeadSlice/addLead",
  LEAD_URL
);

export const updateLead = commonHandleHttpMethodPutV2(
  "LeadSlice/updateLead",
  LEAD_URL
);

const initialState = {
  fetched: false,
  leads: [],
};

const leadSlice = createSlice({
  name: "LeadSlice",
  initialState,
  reducers: {},
  extraReducers: {
    [fetchLeads.fulfilled]: (state, action) => {
      state.fetched = true;
      state.leads = action.payload;
    },
    [fetchLeads.rejected]: (state, action) => {
      state.fetched = false;
    },
    [createLead.fulfilled]: (state, action) => {
      toastrCRUDSuccess("Lead", TEXT_POST);
    },
    [updateLead.fulfilled]: (state, action) => {
      toastrCRUDSuccess("Lead", TEXT_PUT);
    },
  },
});

const { actions, reducer } = leadSlice;
export default reducer;
export const {} = actions;
